import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup, Button, Input } from "reactstrap";
import Select from "react-select";
import { removeEmojis } from "../ReusableComponent/RemoveEmoji";
import axiosInstance from "../configuration/Request";
import Loader from "react-loaders";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import ErrorPopup from "../Components/ErrorPopup";
import { ToastContainer } from "react-toastify";
import { showErrorToast } from "../Components/Toaster";
import { References } from "../../constant/references";
import CharacteristicsOfPatientResponders from "./characteristicsOfPatientResponders";
import { AiOutlineDownload } from "react-icons/ai";
import TooltipComponent from "../ReusableComponent/TooltipComponent";


const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
  };
};

class DrugDiscover extends Component {
  constructor(props) {
    super(props);
    this.initialState = {
      selectedCancerType: null,
      drugName: "",
      resultOptions: [],
      showDetails: false,
      cancerTypeOptions: [],
      drugSuggestions: [],
      filteredSuggestions: [],
      isAvailableInProject_1: false,
      drugBasicDetails: {
        drugTitle: "",
        diseaseDrugId: "",
        cancerType: "",
        histological_subtype: "",
      },
      // respondermRna: [],
      // respondergenes: [],
      openErrorPopup: false,
      RMA_data: {
        excels: [],
        images: [],
      },
      filterReference: [],
      materialsMethodsContent: "",
      drugInfoRes: {},
      noDataMessage:
        " Kindly fill the specifications on the left to get drug discovery/ repurposing results",
    };
    this.state = this.initialState;
    this.suggestionBoxRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    // eventEmitter.on("callhandleDownloadPDF", this.discoveryReportDownload);
    this.setState({ loader: true });
    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}api/drug-discovery`)
      .then((res) => {
        const cancerType = this.processCancerType(res?.data?.cancerTypes);
        this.setState({
          cancerTypeOptions: cancerType,
          drugSuggestions: res?.data?.drugNames,
        });
      })
      .catch((err) => console.log(err))
      .finally(() => this.setState({ loader: false }));
  }

  processCancerType = (dropdownData) => {
    return (
      dropdownData?.map((item) => ({
        label: item,
        value: item,
      })) || []
    );
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  discoveryReportDownload = () => {
    const { drugName, selectedCancerType } = this.state;

    if (drugName && selectedCancerType?.value) {
      this.setState({ loader: true });
      axiosInstance
        .get(
          `${process.env.REACT_APP_BASE_URL}api/drug-discovery/fetch?drugName=${drugName}&cancerType=${selectedCancerType.value}&download=true`,
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/pdf",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${drugName}_Repurposing_Report.pdf`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch((err) => {
          showErrorToast("Download failed");
        })
        .finally(() => this.setState({ loader: false }));
    } else {
      this.setState({ openErrorPopup: true });
    }
  };

  handleClickOutside = (event) => {
    if (
      this.suggestionBoxRef.current &&
      !this.suggestionBoxRef.current.contains(event.target)
    ) {
      this.setState({ showSuggestions: false });
    }
  };

  handleCancerTypeChange = (selectedOption) => {
    this.setState({
      selectedCancerType: selectedOption,
    });
  };

  drugNameChange = (event) => {
    const inputValue = removeEmojis(event.target.value);
    const filtered = this.state.drugSuggestions.filter((drug) =>
      drug.toLowerCase().includes(inputValue.toLowerCase())
    );
    this.setState({
      drugName: inputValue,
      filteredSuggestions: filtered,
      showSuggestions: inputValue.length > 0,
    });
  };

  handleSuggestionClick = (suggestion) => {
    this.setState({
      drugName: suggestion,
      showSuggestions: false,
    });
  };

  handleSubmit = () => {
    const {
      drugSuggestions,
      drugName,
      selectedCancerType,
      cancerTypeOptions,
      noDataMessage,
    } = this.state;
    this.setState({
      ...this.initialState,
      drugSuggestions,
      cancerTypeOptions,
      selectedCancerType,
      drugName,
      noDataMessage,
    });
    this.fetchCharacteristicsOfPatient();
    this.setState({ loader: true });
    axiosInstance
      .get(
        `${process.env.REACT_APP_BASE_URL}api/drug-discovery/fetch?drugName=${this.state.drugName}&cancerType=${this.state.selectedCancerType.value}`
      )
      .then(
        (res) => {
          if (res.data.drug_informations) {

            const efficacyIC50EC50_raw =
              res?.data?.drug_informations[0]?.efficacyIC50EC50;
            const efficacyIC50EC50_noOutlier_raw =
              res?.data?.drug_informations[0]?.efficacyIC50EC50_noOutlier;

            const efficacyIC50EC50 = Array.isArray(efficacyIC50EC50_raw)
              ? efficacyIC50EC50_raw.map((item) => ({
                ...item,
                imageName: `This figure shows the concentrations of drug response in PRISM data, i.e. the half-maximal effective concentration (EC50) and half-maximal inhibitory concentration (IC50), in the CCLE ${res?.data?.drug_informations[0]?.histological_subtype} cell lines. No outliers (defined as drug activity values exceeding 10 μM) were excluded from this plot.`,
              }))
              : [];

            const efficacyIC50EC50_noOutlier = Array.isArray(
              efficacyIC50EC50_noOutlier_raw
            )
              ? efficacyIC50EC50_noOutlier_raw.map((item) => ({
                ...item,
                imageName: `This figure shows the concentrations of drug response in PRISM data, i.e. the half-maximal effective concentration (EC50) and half-maximal inhibitory concentration (IC50), in the Cancer Cell Line Encyclopedia (CCLE) ${res?.data?.drug_informations[0]?.histological_subtype} cell lines. Outliers (defined as drug activity values exceeding 10 μM) were excluded from this plot.`,
              }))
              : [];

            this.setState({
              showDetails: true,
              isAvailableInProject_1: res?.data?.drugInfoMatch,
              drugBasicDetails: {
                drugTitle: res?.data?.drug_informations[0]?.drug_name,
                diseaseDrugId: res?.data?.drug_informations[0]?.disease_drugID,
                cancerType: res?.data?.drug_informations[0]?.cancer_type,
                histological_subtype:
                  res?.data?.drug_informations[0]?.histological_subtype,
              },
              RMA_data: {
                excels:
                  res?.data?.drug_informations[0]?.efficacyIC50EC50_detail ||
                  [],
                images: efficacyIC50EC50.concat(efficacyIC50EC50_noOutlier),
              },
            });
            this.setState(
              {
                materialsMethodsContent: `The Profiling Relative Inhibition Simultaneously in Mixtures (PRISM) framework (Corsello et al., 2020) is a computational tool that estimates drug sensitivities of cancer cell lines using molecular profiling data, particularly gene expression data from the Cancer Cell Line Encyclopedia (CCLE) database. We obtained the PRISM repurposing dataset of the secondary screen from  DepMap (https://depmap.org/portal/download/all/, accessed on 24 April 2025). For this study, we used the PRISM drug response data of ${res?.data?.drug_informations[0]?.histological_subtype} cell lines for NCCN-recommended drugs for systemic or targeted therapy for treating ${res?.data?.drug_informations[0]?.histological_subtype} in the Cancer Cell Line Encyclopedia (CCLE) drug screening data to investigate the drug sensitivity. CCLE ${res?.data?.drug_informations[0]?.histological_subtype} cell line RNA-seq data were obtained from DepMap 24Q4 (https://depmap.org/portal/data_page, accessed on 24 April 2025) (Broad, 2024). CCLE ${res?.data?.drug_informations[0]?.histological_subtype} cell line protein data were obtained from cBioportal (de Bruijn et al., 2023; Gao et al., 2013; Cerami et al., 2012; Ghandi et al., 2019; Nusinow et al., 2020). (https://www.cbioportal.org/datasets, accessed on 24 April 2025). CCLE ${res?.data?.drug_informations[0]?.histological_subtype} cell line miRNA data were obtained from CCLE 2019 release (Ghandi et al., 2019).`,
              },
              () => {
                this.checkForCitations();
              }
            );
          } else {
            this.setState({
              showDetails: false,
              noDataMessage: res.data.message,
            });
          }
        },
        () => {
          this.checkForCitations();
        }
      )

      .catch((err) => {
        console.log(err);
      })
      .finally(() => this.setState({ loader: false }));
  };

  fetchCharacteristicsOfPatient = () => {
    this.setState({ drugInfoRes: {} });
    this.setState({ loader: true });
    const drugName = this.state.drugName;
    axiosInstance
      .get(
        `${process.env.REACT_APP_BASE_URL}api/drug-discovery/drugInfo?drug=${drugName}`
      )
      .then((drugInfoRes) => {
        this.setState({ drugInfoRes: drugInfoRes });
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      })
      .finally(() => this.setState({ loader: false }));
  };

  handleCancel = () => {
    const { drugSuggestions, cancerTypeOptions } = this.state;
    this.setState({
      ...this.initialState,
      cancerTypeOptions,
      drugSuggestions,
    });
  };

  closePopup = () => {
    this.setState({ openErrorPopup: false });
  };

  checkForCitations = () => {
    const foundRefs = [];
    References.forEach((reference) => {
      if (this.state.materialsMethodsContent?.includes(reference.citation)) {
        foundRefs.push(reference);
      }
    });
    this.setState({ filterReference: foundRefs });
    return foundRefs;
  };

  renderHTMLReferenceCheck = (content) => {
    const processed = References.reduce((acc, reference) => {
      const citationHTML = `<span class="citation-link" style="color:#376faa;cursor:pointer" onclick="document.getElementById('reference-${reference.id}')?.scrollIntoView({ behavior: 'smooth', block: 'start' })">${reference.citation}</span>`;
      const escapedCitation = reference.citation.replace(
        /[.*+?^${}()|[\]\\]/g,
        "\\$&"
      );
      return acc.replace(new RegExp(escapedCitation, "g"), citationHTML);
    }, content);

    // Subscript IC50/EC50
    const finalHTML = processed.replace(
      /(IC|EC)50/g,
      (_, prefix) => `${prefix}<sub>50</sub>`
    );

    return <div dangerouslySetInnerHTML={{ __html: finalHTML }} />;
  };

  render() {
    return (
      <div className="row">
        <ToastContainer />
        <div className="col-lg-3 col-md-4 col-sm-12 mt-2">
          <div className="card card-cancerType">
            <div className="drug-discovry-filter">
              <div className="drug-discovery-container">
                <div className="title-div fw-bold d-flex align-items-center mb-3">
                  Compound Evaluation
                </div>
                <div>
                  <div className="discovery-label">Drug Name</div>
                  <div
                    style={{ position: "relative" }}
                    ref={this.suggestionBoxRef}
                  >
                    <Input
                      id="drugNameInput"
                      name="text"
                      placeholder="Enter Drug Name"
                      type="text"
                      className="discovery-input"
                      value={this.state.drugName}
                      minLength={3}
                      maxLength={50}
                      onChange={this.drugNameChange}
                      autoComplete="off"
                    />

                    {this.state.drugName && (
                      <span
                        className="discovery-input-clear"
                        onClick={() =>
                          this.setState({
                            drugName: "",
                            showSuggestions: false,
                            filteredSuggestions: [],
                          })
                        }
                      >
                        &times;
                      </span>
                    )}

                    {this.state.showSuggestions && (
                      <div className="discovery-input-suggession">
                        {this.state.filteredSuggestions.length > 0 ? (
                          <div>
                            {this.state.filteredSuggestions.map(
                              (suggestion, index) => (
                                <div
                                  key={index}
                                  onClick={() =>
                                    this.handleSuggestionClick(suggestion)
                                  }
                                  style={{
                                    padding: "8px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #eee",
                                  }}
                                  onMouseEnter={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    "#f0f0f0")
                                  }
                                  onMouseLeave={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    "transparent")
                                  }
                                >
                                  {suggestion}
                                </div>
                              )
                            )}
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: "8px",
                              color: "#999",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            No data found
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="cancer-type-container mt-2">
                <div className="discovery-label">Cancer Type</div>
                <FormGroup>
                  <Select
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        height: "40px",
                        cursor: "pointer",
                      }),
                      option: (base) => ({
                        ...base,
                        cursor: "pointer",
                      }),
                    }}
                    value={this.state.selectedCancerType}
                    onChange={this.handleCancerTypeChange}
                    options={this.state.cancerTypeOptions}
                    placeholder="Select Cancer Type"
                  />
                </FormGroup>
              </div>
            </div>
            <div className="drugGroup-button">
              <div className="d-flex gap-2">
                <Button
                  className="w-100"
                  color="light"
                  onClick={() => this.handleCancel()}
                >
                  Cancel
                </Button>
                <Button
                  className="w-100"
                  color="primary"
                  disabled={
                    !this.state.drugName.trim() ||
                    !this.state.selectedCancerType
                  }
                  onClick={() => this.handleSubmit()}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-9 col-md-8 col-sm-12 mt-2">
          <div className="card section-container">
            {this.state.showDetails ? (
              <div className="discovery-left-container">
                <div className="discovery-left-header">
                  <div>
                    <div className="drug-title">
                      {this.state.drugBasicDetails.drugTitle}
                    </div>
                    <div className="drug-id">
                      <span>{this.state.drugBasicDetails.diseaseDrugId} </span>
                      {this.state.drugBasicDetails.cancerType && (
                        <span>
                          (Cancer Type: {this.state.drugBasicDetails.cancerType}
                          )
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="d-flex gap-2 align-items-center">
                    <TooltipComponent
                      id="browse-drug-tooltip"
                      tooltipText={!this.state.isAvailableInProject_1 ? "Drug details is not available in the database" : ""}
                    >
                      <Link
                        className={!this.state.isAvailableInProject_1 ? "disabled-link" : ""}
                        target="_blank"
                        to={{
                          pathname: `/app/drugpage?id=${this.state.drugBasicDetails.diseaseDrugId}`,
                        }}
                        onClick={(e) => {
                          if (!this.state.isAvailableInProject_1) {
                            e.preventDefault();
                          }
                        }}
                        style={{ pointerEvents: !this.state.isAvailableInProject_1 ? 'none' : 'auto' }}
                      >
                        <Button
                          style={{ height: "35px" }}
                          color="primary"
                          disabled={!this.state.isAvailableInProject_1}
                        >
                          Browse our repositioning drug database
                        </Button>
                      </Link>
                    </TooltipComponent>
                    <div className="download-pdf" title="Download Discovery Report">
                      <AiOutlineDownload
                        size={"1.5rem"}
                        onClick={this.discoveryReportDownload}
                      />
                    </div>
                  </div>
                </div>
                <div className="discovery-content">
                  {this.state.RMA_data && (
                    <div className="discovery-sections">
                      <div>
                        <div className="drug-subtitle mb-2">
                          Materials and Methods
                        </div>
                        <div className="description-text mb-2">
                          {this.renderHTMLReferenceCheck(
                            this.state.materialsMethodsContent
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="drug-subtitle mb-2">Results</div>

                        {(() => {
                          const { images } = this.state.RMA_data;
                          if (images.length > 0) {
                            return images.map((img) => (
                              <React.Fragment key={img.id}>
                                <div className="d-flex justify-content-center align-items-center mt-3">
                                  <img
                                    src={img.url}
                                    alt={img.name}
                                    className="discovery-image"
                                  />
                                </div>
                                <div className="d-flex justify-content-center align-items-center description-text mb-2 mt-1">
                                  {img.imageName}
                                </div>
                              </React.Fragment>
                            ));
                          } else {
                            return (
                              <div className="no-record">
                                No records available
                              </div>
                            );
                          }
                        })()}
                      </div>

                      {/* Excel Download Links */}
                      {this.state.RMA_data.excels.length > 0 && (
                        <div className="my-3">
                          <div className="drug-subtitle mb-1">
                            IC50/EC50 Details
                          </div>

                          <div className="description-text mb-2">
                            The following table shows all available half-maximal
                            effective concentration (EC 50 ) and half- maximal
                            inhibitory concentration (IC 50 ) values for{" "}
                            {this.state.drugName} in CCLE{" "}
                            {this.state.drugBasicDetails.histological_subtype}{" "}
                            cell lines.
                            {this.state.RMA_data.excels.map((file) => (
                              <a
                                key={file.id}
                                href={file.url}
                                download={file.name}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                📥 Click Here
                              </a>
                            ))}{" "}
                            to download
                          </div>
                          {/* <div className="description-text mb-2">
                            The{" "}
                            {this.state.drugBasicDetails.histological_subtype}{" "}
                            cell lines were classified as resistant if their
                            half-maximal inhibitory concentration (IC50) or
                            half-maximal effective concentration (EC50) values
                            of the studied drug exceeded the maximum dose (10
                            µm); conversely, cell lines were classified as
                            sensitive if their IC50 or EC50 values of the
                            studied drug were below the minimum dose (0.0006
                            µm). Utilizing the mean ± 0.5 standard deviations of
                            the drug sensitivity measurements, the remaining
                            cell lines were categorized into three groups:
                            sensitive, partial response, or resistant.
                          </div> */}
                        </div>
                      )}
                    </div>
                  )}

                  {Object.keys(this.state.drugInfoRes).length > 0 && (
                    <CharacteristicsOfPatientResponders
                      drugInformation={this.state.drugInfoRes}
                      drugDetails={this.state.drugBasicDetails}
                    />
                  )}

                  <div className="discovery-sections mt-3">
                    <div className="drug-subtitle mb-2">References</div>
                    {this.state.filterReference.map((ref) => (
                      <div
                        className="reference-text"
                        key={ref.id}
                        id={`reference-${ref.id}`}
                        style={{ marginBottom: "4px" }}
                      >
                        <a
                          href={ref.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none", color: "#376faa" }}
                        >
                          {ref.description}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="text-center fw-bold d-flex justify-content-center align-items-center"
                style={{ height: "100%" }}
              >
                {this.state.noDataMessage}
              </div>
            )}
          </div>
        </div>
        {this.state.loader && (
          <div className="backdrop">
            <div className="loader">
              <Loader type="ball-pulse-rise" />
            </div>
          </div>
        )}
        <SweetAlert
          custom
          show={this.state.openErrorPopup}
          customButtons={<React.Fragment></React.Fragment>}
          style={{ width: "auto", padding: "1rem" }}
        >
          <ErrorPopup
            closeAlert={this.closePopup}
            title="Both drug name and cancer type are required to download the report."
            buttonTitle="Close"
          ></ErrorPopup>
        </SweetAlert>
      </div>
    );
  }
}

export default connect(mapStateToProps)(DrugDiscover);
